import React from "react";
import { Hero } from "../components/sections/Hero";
import { Pathway } from "../components/sections/Pathway";
import { BeforeAfter } from "../components/sections/BeforeAfter";
import { Situations } from "../components/sections/Situations";
import { Volumes } from "../components/sections/Volumes";
import { Toolkit } from "../components/sections/Toolkit";
import { Bonuses } from "../components/sections/Bonuses";
import { Offer } from "../components/sections/Offer";
import { Guarantee } from "../components/sections/Guarantee";
import { Testimonials } from "../components/sections/Testimonials";
import { Creator } from "../components/sections/Creator";
import { Faq } from "../components/sections/Faq";
import { FinalCta } from "../components/sections/FinalCta";
import { Footer } from "../components/sections/Footer";
import { FloatingCta } from "../components/FloatingCta";
import { PurchasePopup } from "../components/PurchasePopup";
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-320" data-mp="3ajghiyoklnyh">
      <Hero data-id="element-321" data-mp="35t02xb90jwaj" />
      <main data-id="element-322" data-mp="35t9rqvibnxen">
        <Pathway data-id="element-323" data-mp="35sqalh0hxd1o" />
        <BeforeAfter data-id="element-324" data-mp="35s86xzbi7wjq" />
        <Situations data-id="element-325" data-mp="35rp0berb0ul0" />
        <Volumes data-id="element-326" data-mp="30twwpnhark0z" />
        <Toolkit data-id="element-327" data-mp="30tdq32x3ki29" />
        <Bonuses data-id="element-328" data-mp="30uyl0tnbq30n" />
        <Offer data-id="element-329" data-mp="30ugft7iooegl" />
        <Guarantee data-id="element-330" data-mp="30u6rdodaefd0" />
        <Testimonials data-id="element-331" data-mp="2vuu2ky2uuy7s" />
        <Creator data-id="element-332" data-mp="2vvc6mgvregq9" />
        <Faq data-id="element-333" data-mp="2vvvd91fylioz" />
        <FinalCta data-id="element-334" data-mp="2vwexwpwzul6p" />
      </main>
      <Footer data-id="element-335" data-mp="2vszhnjrl363p" />
      <FloatingCta data-id="element-336" data-mp="3tica65ks5ua7" />
      <PurchasePopup data-id="element-337" data-mp="3tiuelphljet7" />
    </div>;
}